import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StoreServicesComponent } from '@teem/service-module/store-services.component';


const routes: Routes = [
	{
		path: "",
		component: StoreServicesComponent
	}
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StoreServicesRoutingModule { }
